<template>
    <modal :modal-id="modalId"
           :class="modalBodyClass"
                     :title="modalTitle"
                     :preloader="preloader"
           :modalExtraButton="modalExtraButton"
                     @submit="submit"
                     @close-modal="closeModal">
        <template slot="body">
            <app-overlay-loader v-if="preloader"/>
            <form class="col-md-9 pl-1 pr-0"
                  :class="{'loading-opacity': preloader}"
                  ref="form" :data-url='selectedUrl ? `admin/app/templates/${inputs.id}` : `admin/app/templates`'>

                <div class="row col-sm-12 justify-content-between half-width-container pr-0 mb-4">
                    <div class="form-group row align-items-center md-half-width">
                        <label for="inputs_name" class="col-sm-12 mb-0">
                            {{ $t('mail_template_name') }}
                        </label>
                        <app-input id="inputs_name"
                                   class="col-sm-12 pr-0"
                                   type="text"
                                   v-model="inputs.name"
                                   :placeholder="$t('text_type_input')"
                                   :required="true"/>

                    </div>
                    <div class="form-group row align-items-center md-half-width">

                    </div>
                </div>
                <div class="row col-sm-12 justify-content-between half-width-container pr-0">
                    <div class="form-group row align-items-center col-sm-8 pl-0 pr-0">
                        <label for="inputs_title" class="col-sm-12 mt-3 mb-0">
                            {{ $t('template_title_and_text') }}
                        </label>
                        <app-input id="inputs_title"
                                    class="col-sm-12 pr-0"
                                    type="text"
                                   v-model="inputs.title"
                                   :placeholder="$t('text_type_input')"/>
                    </div>
                    <div v-if="this.inputs.status == 1" class="form-group row align-items-center col-sm-4 pl-0 pr-0">
                        <div class="col-sm-12 pr-0 mb-0">
                            <span class="template-selection">
                                <div class="row">
                                <label for="inputs_title" class="col-sm-10 mt-3 mb-0">
                                    {{ $t('choose_from_template') }}
                                </label>
                                <a href="/mail-templates" target="_blank" class="col-md-2 mt-3 text-right text-muted" :title="$t('edit_templates')">
                                    <app-icon :name="'edit'" width="18" height="18"/>
                                </a>
                            </div>

                                <app-input id="inputs_template"
                                   class="pr-0"
                                   type="select"
                                   v-model="template"
                                   :list="templateOptions"/>
                            </span>
                        </div>

                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <app-overlay-loader v-if="editorPreloader"/>
                    <app-input v-if="finishedGetData" id="inputs_body"
                               class="col-sm-12"
                               type="text-editor"
                               v-model="inputs.body"
                               :placeholder="$t('text_type_input')"
                               />
                    <app-input v-if="editorPreloader"
                               id="inputs_text_blind"
                               class="col-sm-12"
                               :class="{'loading-opacity': editorPreloader}"
                               type="textarea"/>

                </div>
                <div class="form-group row align-items-center">
                    <div class="note note-info ml-1 mt-3 p-4 col-sm-9 mb-3">
                        Váš podpis s fotkou níže bude přidán automaticky, nezadávejte ho do těla šablony:
                        <div v-html="this.getDefaultSignature()"></div>
                    </div>
                </div>


                <br>
            </form>
        </template>
    </modal>
</template>

<script>
    import {FormMixin} from '../../../../../../core/mixins/form/FormMixin.js';
    import {ModalMixin} from "../../../../../Mixins/ModalMixin";
    import {UserMixin} from "../../../../../../app/Components/Views/Auth/Mixins/UserMixin";

    export default {
        name: "AddModal",
        mixins: [FormMixin, ModalMixin, UserMixin],
        props: {
            tableId: String,
            modalExtraButton: String
        },
        watch: {
          template: {
            sync: true,
            handler (val, oldVal) {
                if(val != 0){
                    this.getTemplateData();
                }
            }
          }
        },
        data() {
            return {
                preloader: false,
                editorPreloader: false,
                finishedGetData: false,
                inputs: {
                    status: 1,
                    name: '',
                    title: '',
                    body: '',
                    tasks: '',

                },
                template: 0,
                templateOptions: [
                    {id: 0, value: this.$t('select'),},
                ],
                statusLists: [
                    {id: 1, value: "E-mail",},
                ],
                modalId: 'add-edit-Modal',
                modalBodyClass: 'simple-modal',
                modalTitle: this.$t('add'),
            }
        },
        created() {

            if (this.selectedUrl) {
                this.modalTitle = this.$t('edit');
                this.preloader = true;
            } else {
                if(this.tableId == 'mailTemplates'){
                    this.inputs.status = 1;
                }

            }


            // Display available mail/checklist templates
            let url = 'admin/app/templates?filter_with_status_id=1&per_page=500';
            this.axiosGet(url).then(response => {

                const templateOptionsArray = response.data.data.map(({
                  name: value,
                  ...rest
                }) => ({
                  value,
                  ...rest
                }));

                this.templateOptions = templateOptionsArray;
                this.templateOptions.unshift({"id": 0, "value": this.$t('select')});

            }).catch(({response}) => {
            }).finally(() => {
                this.getMessageFooter();
                this.finishedGetData = true;
            });

        },
        methods: {

            /**
             * Save as Template and Fill from Template
             */
            getTemplateData() {
                let selectedTemplateId = parseInt(this.template);
                let templates = this.templateOptions;
                const selectedTemplate = templates.find(o => o.id === selectedTemplateId);

                this.finishedGetData = false;
                this.editorPreloader = true;
                this.inputs.title = selectedTemplate.title;
                this.inputs.body = selectedTemplate.body;

                let _this = this;
                setTimeout(function(){
                    _this.finishedGetData = true;
                    _this.editorPreloader = false;
                }, 500);
            },
            getDefaultSignature() {
                let photo = '';
                if(this.user.loggedInUser.img){
                    photo = '<td style="width: 100px"><img src="'+this.user.loggedInUser.img+'" height="60"></td>';
                }
                return '<br><br><table align="left"><tbody><tr>'+photo+'<td><b>'+this.user.loggedInUser.full_name+'</b><br>'+this.user.loggedInUser.roles[0].name+'<br>'+this.user.loggedInUser.email+'</td></tr></tbody></table><br><br><br>';
            },
            getMessageFooter() {
                let _this = this;
                setTimeout(function(){
                    let photo = '';
                    console.log(_this.user.loggedInUser.profile_picture);
                    console.log("messagefooter");
                    if(_this.user.loggedInUser.img){
                        photo = '<td style="width: 100px"><img src="'+_this.user.loggedInUser.img+'" height="60"></td>';
                    }
                    let messageSuffix = '<br><br><table align="left"><tbody><tr>'+photo+'<td><b>'+_this.user.loggedInUser.full_name+'</b><br>'+_this.user.loggedInUser.roles[0].name+'<br>'+_this.user.loggedInUser.email+'</td></tr></tbody></table><br><br><br>';


                    _this.inputs.body = 'Doplňte text zprávy...<br><br>'+messageSuffix;
                }, 1500);
            },

            /**
             * Save form
             */
            submit() {
                this.save(this.inputs);

            },
            afterSuccess(response) {
                this.$toastr.s(response.data.message);
                this.$hub.$emit('reload-' + this.tableId);
            },

            afterSuccessFromGetEditData(response) {
                this.inputs = response.data;

                this.preloader = false;
                this.finishedGetData = true;

                // Add visited candidate to history
                if (history.replaceState && location.href.indexOf("?id") <= 0) {
                    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?id='+this.inputs.id;
                    window.history.replaceState({path:newurl},'',newurl);
                }
            },



        },
    }
</script>
